var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { api } from './baseApi';
export var feedApi = api.injectEndpoints({
    endpoints: function (builder) {
        return ({
            getFeedPostsAdmin: builder.query({
                query: function (_a) {
                    var _b = _a.page, page = _b === void 0 ? 1 : _b, _c = _a.limit, limit = _c === void 0 ? 20 : _c, restaurantId = _a.restaurantId, search = _a.search, reportedOnly = _a.reportedOnly;
                    return ({
                        url: '/feed/admin/posts',
                        method: 'GET',
                        params: __assign(__assign(__assign({ page: page, limit: limit }, (restaurantId ? { restaurantId: restaurantId } : {})), (search ? { search: search } : {})), (reportedOnly ? { reportedOnly: true } : {})),
                    });
                },
                providesTags: ['Feed'],
            }),
            getFeedPostAdmin: builder.query({
                query: function (id) {
                    return ({
                        url: "/feed/admin/posts/".concat(id),
                        method: 'GET',
                    });
                },
                providesTags: function (_result, _error, id) { return [{ type: 'Feed', id: id }]; },
            }),
            deleteFeedPostAdmin: builder.mutation({
                query: function (id) {
                    return ({
                        url: "/feed/admin/posts/".concat(id),
                        method: 'DELETE',
                    });
                },
                invalidatesTags: ['Feed'],
            }),
            getFeedReportedCount: builder.query({
                query: function () {
                    return ({
                        url: '/feed/admin/reports/pending-count',
                        method: 'GET',
                    });
                },
                providesTags: ['Feed'],
            }),
        });
    },
});
export var useGetFeedPostsAdminQuery = feedApi.useGetFeedPostsAdminQuery, useGetFeedPostAdminQuery = feedApi.useGetFeedPostAdminQuery, useDeleteFeedPostAdminMutation = feedApi.useDeleteFeedPostAdminMutation, useGetFeedReportedCountQuery = feedApi.useGetFeedReportedCountQuery;
